import * as React from "react"

const SvgLightbulb = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="M12 22.286q-.825 0-1.412-.588A1.93 1.93 0 0 1 10 20.286h4q0 .825-.588 1.412a1.93 1.93 0 0 1-1.412.588m-3-3a.97.97 0 0 1-.713-.288.97.97 0 0 1-.287-.712.97.97 0 0 1 .287-.713.97.97 0 0 1 .713-.287h6a.97.97 0 0 1 .713.287q.287.288.287.713c0 .425-.096.52-.287.712a.97.97 0 0 1-.713.288zm-.75-3a7.66 7.66 0 0 1-2.737-2.75A7.3 7.3 0 0 1 4.5 9.786q0-3.126 2.188-5.313Q8.875 2.286 12 2.286c3.125 0 3.854.729 5.313 2.187q2.186 2.188 2.187 5.313 0 2.025-1.012 3.75a7.66 7.66 0 0 1-2.738 2.75zm.6-2h6.3a5.55 5.55 0 0 0 1.737-1.975 5.4 5.4 0 0 0 .613-2.525q0-2.301-1.6-3.9-1.6-1.6-3.9-1.6c-2.3 0-2.833.533-3.9 1.6q-1.6 1.599-1.6 3.9 0 1.35.612 2.525a5.55 5.55 0 0 0 1.738 1.975" />
  </svg>
)
export default SvgLightbulb
